import { render, staticRenderFns } from "./MyPhoto.vue?vue&type=template&id=24823308&scoped=true&"
import script from "./MyPhoto.vue?vue&type=script&lang=js&"
export * from "./MyPhoto.vue?vue&type=script&lang=js&"
import style0 from "./MyPhoto.vue?vue&type=style&index=0&id=24823308&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24823308",
  null
  
)

export default component.exports